import NameLinkCell from '@/components/NameLinkCell';
import type { SampleWithNamesPublic } from '@/types';
import React, { type FC, memo } from 'react';
import { useTranslation } from 'react-i18next';

export interface StudyCellRendererProps {
  data?: SampleWithNamesPublic;
}

const StudyCellRendererComponent: FC<StudyCellRendererProps> = ({ data }) => {
  const { t } = useTranslation('studies');

  if (!data) return null;

  return (
    <NameLinkCell
      ariaLabel={t('goToStudy')}
      id={data.study_id}
      name={data.study_name}
      params={{ studyId: String(data.study_id) }}
      size="xs"
      testId="study-link-button"
      to="/studies/$studyId"
    />
  );
};

const MemoizedStudyCellRenderer = memo(StudyCellRendererComponent);

export default MemoizedStudyCellRenderer;
